import React, { Component} from 'react';
import Error from "../pages/Error";
import globals from "../globals";

class ErrorBoundary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true
        });

        globals.handleException(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Error />
            );
        }

        return this.props.children;
    }

}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/ErrorBoundary.js